<template>
    <div class="table_container">
      <div class="table-btn" style="margin: 24px 0 12px 0">
        <el-button
          v-if="$route.query.operateType !== '查看'"
          :disabled="tableData.length >= 15"
          type="primary"
          size="small"
          @click="handleAdd()"
          >添加</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
        :cell-class-name="cellClassName"
        @cell-click="handleCellClick"
      >
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="requirementsThings"
          label="要求事项"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'requirementsThings' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.requirementsThings"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.requirementsThings }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="completionDate"
          label="完成日期"
          min-width="110px"
          align="center"
        >
          <template slot-scope="scope">
           
            <el-date-picker
            v-if="editField === 'completionDate' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.completionDate"
              type="date"
              placeholder="选择日期"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @change="confirmEdit"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd">
            </el-date-picker>
            <div v-else>
              {{ scope.row.completionDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="undertaking"
          label="承接人"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'undertaking'
              "
              id="focusRef"
              v-model="scope.row.undertaking"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.undertaking }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="deliverables"
          label="交付物"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'deliverables' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.deliverables"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.deliverables }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="businessImpact"
          label="对业务的影响"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'businessImpact' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.businessImpact"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.businessImpact }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'remark' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.remark"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$route.query.operateType !== '查看'"
          label="操作"
          align="center"
          width="90px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>
  
  <script>

  import { addOrUpdateRequirementApi } from "@/api/saleTaskCollection";
  
  export default {
    data() {
      return {
        tableData: [],
        editField: "", // 编辑单元格
        editIndex: -1 // 编辑行索引
      };
    },
    methods: {
      init(data) {
        this.tableData = (data||[]);
        
      },
      // 添加
      handleAdd() {
        this.tableData.push({
            requirementsThings:"",
            completionDate:"",
            undertaking:"",
            deliverables:"",
            businessImpact:"",
            remark:""
        });
      },
      // 删除
      handleDelete(index) {
        this.tableData.splice(index, 1);
      },

      // 获取单元格索引
      cellClassName({ row, column, rowIndex, columnIndex }) {
        row.index = rowIndex;
        column = { ...column, index: columnIndex };
      },
      // 点击单元格
      handleCellClick(row, column) {
        this.handleColumn(column.property, row.index ?? -1);
        this.tableData[row.index][column.property] =
          this.tableData[row.index][column.property] ?? undefined;
      },
      // 点击单元格编辑
      handleColumn(field, index) {
        if (this.$route.query.operateType === "查看") return;
        this.editField = field;
        this.editIndex = index ?? -1;
        this.$nextTick(() => {
          document.querySelector("#focusRef")?.focus();
          document.querySelector("#focusRef .el-input__inner")?.focus();
        });
      },
      // 确认编辑
      confirmEdit() {
        this.editField = "";
        this.editIndex = -1;
      },
      // el-select 显示隐藏选项框时触发
      visibleChange(visible) {
        if (!visible) {
          this.confirmEdit();
        }
      },
      // 保存
      async handleSave(params) {
        try {
          const submitData = {
            ...params,
            dataList: this.tableData
          };
         
          const res = await addOrUpdateRequirementApi(submitData);
          if (res.status == 0) {
            this.$DonMessage.success("操作成功！");
            this.tableData = res.data
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .table_container {
    padding: 15px 18px 0 50px;
    .number_input {
      width: 100%;
      padding: 0;
      ::v-deep .el-input__inner {
        padding: 0 8px;
      }
    }
  }
  </style>
  